import React from "react";

const Services = () => {
  return <div>hi</div>;
};

export default Services;
